import { NormalisedFilter } from 'v2/querybuilder/types/querystore';

export function isFilterValueEmpty(filter: NormalisedFilter) {
  switch (filter.value.type) {
    case 'boolean':
    case 'number':
    case 'string':
      return !filter.value.value;
    case 'boolean[]':
    case 'number[]':
    case 'string[]':
      return !filter.value.values.length;
    default:
      return true;
  }
}
